export const useStoreCountries = defineStore('StoreCountries', {
    state: () => ({
        countries: null,
        error: null,
        filter: {
            paginate: {
                auto: false
            },
            order: [
                {field: 'country_priority', asc: false},
                {field: 'country_name', asc: true},
            ],
        },
    }),
    actions: {
        getCountries: async function () {
            if (this.countries) return true;
            this.error = null;
            ({countries: this.countries, error: this.error} = await useQueryCountries().get(this.filter));
        },
    },
});
